



















































































import Vue from 'vue';
import {ENDPOINTS, get, post} from "@/api/mainApi";
import {Sms} from "@/interfaces/sms";
import {Snackbar} from "@/interfaces/presentation/snackbar";
import {Donation} from "@/interfaces/donation/donation";
import {SmsType} from "@/enums/smsType";
import LabelMixin from '@/mixins/labelMixin';
import ValidationMixin from '@/mixins/validationMixin';

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    donation: {
      type: Object as () => Donation,
    },
    message: {
      type: String,
      default: ''
    },
  },
  mixins: [ValidationMixin, LabelMixin],
  data() {
    return {
      errorDialog: false,
      errorMessage: '',
      smsValidationWaitTime: 4000,
      valid: true,
      loading: false,
    };
  },
  computed: {

  },
  watch: {
    show(value) {
      this.errorDialog = value;
    },
    message(value) {
      this.errorMessage = value;
    }
  },
  methods: {
    goToPaymentMethodSelection() {
      this.$emit('toPaymentSelection', true);
    },
    resendSms() {

      if (!this.$refs.formMobileNumber.validate()) {
        return;
      }

      this.submitError = false;

      this.loading = true;

      // resend the SMS
      post(ENDPOINTS.SMS + "/" + ENDPOINTS.SEND + "/" + ENDPOINTS.PAY_REQUEST + "?serialNumber=" + this.donation.serialnumber + "&mobileNumber=" + this.donation.donor.mobileNumber, {})

        // If we were able to resend it, then check if there is an error
        .then(res => {

          setTimeout(() => {

            get(ENDPOINTS.SMS + "/" + ENDPOINTS.DONATION + "/" + this.donation.serialnumber + "/" + ENDPOINTS.LATEST + "/" + SmsType.PAY_REQUEST)

              .then((sms: Sms) => {

                if (sms.errorMessage && sms.errorMessage.length > 0) {

                  this.errorMessage = sms.errorMessage;

                  let snackbar: Snackbar = {
                    active: true,
                    color: "error",
                    text: this.$t('paylink.error.paymentLinkCouldNotBeSent'),
                    timeout: 10000,
                    action: null
                  };

                  this.$store.commit('setSnackbar', snackbar);
                  this.loading = false;

                } else {
                  let snackbar: Snackbar = {
                    active: true,
                    color: "success",
                    text: this.$t('payLinkSend.messages.payLinkSend.error'),
                    timeout: 8000,
                    action: null
                  };
                  this.$store.commit('setSnackbar', snackbar);

                  this.$emit('toSuccess');
                  this.errorDialog = false;
                  this.loading = false;
                }
              }).catch(err => {
                this.errorMessage = this.$t('payLinkSend.messages.payLinkSend.errorCheckPhoneNumber')
                let snackbar: Snackbar = {
                  active: true,
                  color: "error",
                  text: this.$t('payLinkSend.messages.payLinkSend.error'),
                  timeout: 10000,
                  action: null
                };
                this.$store.commit('setSnackbar', snackbar);
                this.loading = false;
            })
          }, this.smsValidationWaitTime)
        })
        .catch(err => {
          console.log(err);
          this.errorMessage = this.$t('payLinkSend.messages.payLinkSend.probableErrorCheckPhoneNumber')
          let snackbar: Snackbar = {
            active: true,
            color: "error",
            text: this.$t('payLinkSend.messages.payLinkSend.error'),
            timeout: 10000,
            action: null
          };
          this.$store.commit('setSnackbar', snackbar);
          this.loading = false;
        })
    },
  },
});
